module.exports = __webpack_public_path__ + "img/steps6-2.en.5715fb43.png";